/* RESPONSIBLE TEAM: team-inbox */
import { get } from '@ember/object';
import { isPresent } from '@ember/utils';

export default function (response) {
  if (response === null || typeof response !== 'object' || Object.keys(response).length === 0) {
    return null;
  } else if (isPresent(response.jqXHR) && isPresent(response.jqXHR.responseJSON?.errors)) {
    let error = Array.isArray(response.jqXHR.responseJSON?.errors)
      ? get(response, 'jqXHR.responseJSON.errors.firstObject')
      : get(response, 'jqXHR.responseJSON.errors');
    return { status: response.jqXHR.status, ...error };
  } else if (
    isPresent(response.jqXHR) &&
    isPresent(response.jqXHR.responseJSON?.error) &&
    typeof response.jqXHR.responseJSON.error === 'string'
  ) {
    return { status: response.jqXHR.status, message: response.jqXHR.responseJSON.error };
  } else if (isPresent(response.responseJSON)) {
    return get(response, 'responseJSON.errors.firstObject');
  } else if (isPresent(get(response, 'jqXHR.status'))) {
    return { status: response.jqXHR.status };
  } else {
    return get(response, 'errors.firstObject');
  }
}
